import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {
  constructor() {}

  public saveAsExcelFile(data: any, fileName: string): void {
    const dataExcel = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    FileSaver.saveAs(dataExcel, fileName);
  }

  public saveFile(data: any, fileName: string, type: string) {
    const file = new Blob([data], {type: 'application/pdf'} );
    FileSaver.saveAs(file, fileName + '.' + type);
  }
}
